import React from "react";
import { useFela } from "react-fela";

import { Heading } from "@/components/Heading";
import { Image } from "@/components/Image";
import { IBlogCard } from "@/containers/BlogCard/types";
import { getButtonStyles } from "@/components/Button/helpers/getButtonStyles";
import { Icon, StyledIconWrapper } from "@/components/Icon";
import { IIconType } from "@/icons";
import { useTheme } from "../../../hooks/useTheme";

export const TutorialBlogCard: React.FC<IBlogCard> = ({
  title,
  content,
  media,
  href,
  buttonLabel,
  buttonIcon = "ARROW-WHITE" as IIconType,
}) => {
  const { css } = useFela();
  const { colors, bp } = useTheme();
  const styles = getButtonStyles("PRIMARY");

  return (
    <div
      className={css({
        maxWidth: 340,
        margin: "0 auto",
        alignItems: "flex-start",
        textAlign: "left",
        [bp.FROM_DESKTOP]: { width: 227 },
        [bp.FROM_LARGE_DESKTOP]: { minHeight: 440 },
      })}
    >
      <Image src={media.src} alt={media.alt} customStyle={{ width: "100%" }} />
      <Heading as="h4" customStyle={{ marginBottom: 16, marginTop: 16 }}>
        {title}
      </Heading>

      <p
        className={css({
          height: 80,
          overflow: "hidden",
          color: colors.DARK_GREY,
          margin: "0 0 20px",
          fontSize: 18,
          lineHeight: 1.44,
          letterSpacing: 0.44,
        })}
      >
        {content}
      </p>

      <a
        href={href}
        target="_blank"
        rel="noreferrer"
        className={css({
          display: "block",
          margin: "auto 0 0",
          letterSpacing: 0.44,
          color: colors.WHITE,
          fontWeight: "normal",
          [bp.FROM_DESKTOP]: {
            maxWidth: "90%",
          },
          ...styles,
        })}
      >
        <span>{buttonLabel}</span>
        {buttonIcon && (
          <StyledIconWrapper customStyle={{ marginLeft: 10 }}>
            <Icon iconType={buttonIcon} />
          </StyledIconWrapper>
        )}
      </a>
    </div>
  );
};
